export default __webpack_public_path__ + "images/next-gray.svg?3ccce252f2cdddb2428d613d38e08cf9";